import { getWaitingTime } from "utils/dateUtils";

export const getWaitingTimeTvSecFolderHelp = (folderHelp) => {
	if (folderHelp.historics && folderHelp.historics.filter((h) => h.status_to === "NEW").length > 0)
		return (
			<span style={{ padding: "0 4px" }}>
				{getWaitingTime(
					folderHelp.historics.filter((h) => h.status_to === "NEW")[0].created_at,
					folderHelp.historics.filter((h) => h.status_to === "REASSIGNED" || h.status_to === "CANCELED" || h.status_to === "CANCELEDBYSEC").length > 0
						? folderHelp.historics.filter((h) => h.status_to === "REASSIGNED" || h.status_to === "CANCELED" || h.status_to === "CANCELEDBYSEC")[0]
								.created_at
						: null
				)}
			</span>
		);
};
